export const SeasonSansFontFamily = "'Season Sans', 'Open Sans', sans-serif";
export const SeasonMixFontFamily = "'Season Mix', 'Open Sans', sans-serif";

export const applicationSidePaddingPx = 16;
export const paywallHeaderHeightPx = 72;
export const contentMaxWidthPx = 532;

export const stickyFooterHeightCssVar = '--sticky-footer-height';

// Touch screens keep :hover on hold and after a tap, so hover styles apply to real pointers only
export const pointerHoverMediaQuery = '@media (hover: hover)';
